/**
 * Created by zhoay on 2023/6/14
 * Desc: 合影费
 */
import React, { Component } from 'react'
import { List, Toast, Form, Stepper } from "antd-mobile";
import { fetchGet, fetchPost, fetchPostObj } from '../../../utils/fetchRequest'
import { API } from '../../../configs/api.config'
import { getSearchParams, isObjEmpty, getIntValue, getStrValue, } from '../../../utils/common'
import { Icon, message, Button, Cascader, InputNumber } from 'antd'
import './PreviewApply.css';
import { connect } from 'react-redux'

class GroupApply extends Component {

    componentWillMount() {
        document.title = "合影费用";
    }

    constructor() {
        super()

        this.state = {
            schoolName: null,
            gradeClazz: null,
            stuName: null,
            clazzId: 0,
            schoolId: 0,
            appId: null,
            openId: null,
            changed: 1,
            money: 0,
        }
    }

    componentDidMount() {
        Toast.loading('努力加载中...', 0)

        this.searchParams = getSearchParams(this.props.location.search)
        this.setState({
            clazzId: this.searchParams.clazzId,
            schoolId: this.searchParams.schoolId,
            appId: this.searchParams.appId,
            openId: this.searchParams.openId,
        })

        this.getSchoolList()

    }

    render() {
        const { schoolName, gradeClazz, stuName, money } = this.state;

        return (
            <div className='preview-page-root'>
                <div className='head-preview-page'>
                    <div style={{ textAlign: 'center' }}>
                        <img className='head-word-page' src={require('imgs/Album_b.png')} />
                    </div>
                </div>
                <div className="tail-preview-page">
                    <div className="album-container" ref={node => this.node = node} onChange={this.handelValueCom}>
                        <div style={{ margin: '5px 10px 5px 10px', background: 'white', borderRadius: '10px' }}>
                            <div className="item_sty">
                                <div className="left_title">学校</div><div className={'form-input-fill'}>*</div>
                                <input ref='schoolName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" disabled="disabled" value={this.state.schoolName} />
                            </div>

                            <div className="comhline_sty1"></div>

                            <div className="item_sty">
                                <div className="left_title">班级</div><div className={'form-input-fill'}>*</div>
                                <input ref='gradeClazz' className="text-right right_input" type="text" placeholder="班级" maxLength={20} autoFocus="autoFocus" value={this.state.gradeClazz} />
                            </div>

                            <div className="comhline_sty1"></div>

                            <div className="item_sty">
                                <div className="left_title">姓名</div><div className={'form-input-fill'}>*</div>
                                <input ref='stuName' className="text-right right_input" type="text" placeholder="学生姓名" maxLength={20} autoFocus="autoFocus" value={this.state.stuName} />
                            </div>

                            <div className="comhline_sty1"></div>

                            <div className="item_sty">
                                <div className="left_title">金额</div>
                                <input ref='money' className="text-right right_input" type="text" placeholder="金额" maxLength={20} autoFocus="autoFocus" disabled="disabled" value={this.state.money} />
                            </div>

                            <div className="comhline_sty1"></div>

                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <img src={require('imgs/Album_c.png')} width={104} height={52} style={{ margin: '45px', white: 'white', textAlign: 'center' }} onClick={this.onNextClick} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getSchoolList = () => {
        Toast.loading('', 0);

        fetchGet(API.ALBUM_CLAZZ, {
            clazzId: this.searchParams.clazzId,
            schoolId: this.searchParams.schoolId
        }).then(response => {
            Toast.hide();
            if (response && response.data) {
                this.setState({
                    schoolName: response.data.schoolName,
                    money: response.data.upMoney,
                    appid: response.data.appid,
                })

            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    onNextClick = (amount) => {

        const { schoolName, gradeClazz, stuName, appId, openId, changed, money, clazzId, schoolId } = this.state

        let err = ''

        if (money <= 0) {
            Toast.show('请输入正确的充值金额！')
            return
        }
        if (isObjEmpty(schoolName)) {
            Toast.fail('请输入学校')
            return
        }
        if (isObjEmpty(gradeClazz)) {
            Toast.fail('请输入班级')
            return
        }
        if (isObjEmpty(stuName)) {
            Toast.fail('请输入学生姓名')
            return
        }

        const params = {
            school_name: schoolName,
            gradeClazz: gradeClazz,
            person_name: stuName,
            number: changed,
            sumMoney: money,
            clazz_id: clazzId,
            school_id: schoolId,
            type: 2,
            appId: appId,
            openId: openId,
        }

        fetchPost(API.ALBUM_CHARGE_ORDER, { params: JSON.stringify(params) },
            {})
            .then((response) => {
                Toast.hide()
                const data = response.data
                err = data
                if (err === undefined) {
                    err = response.message;
                }
                if (typeof WeixinJSBridge == 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady',
                            this.onBridgeReady(data), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady',
                            this.onBridgeReady(data))
                        document.attachEvent('onWeixinJSBridgeReady',
                            this.onBridgeReady(data))
                    }
                } else {
                    this.onBridgeReady(data)
                }
            }).catch((error) => {
                console.log('error:' + JSON.stringify(error))
                Toast.show('支付失败！' + err)
            })
    }

    onBridgeReady = (json) => {
        console.log('json:', json)
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', JSON.parse(json),
            function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    Toast.success('支付成功！')
                    this.props.history.push('/previewPage/1')
                } else {
                    Toast.fail('支付失败！')
                    this.props.history.push('/previewPage/2')
                }
            })
    }

    handelValueCom = (event) => {
        //获取用户名的值
        let schoolName = this.refs.schoolName.value;
        let gradeClazz = this.refs.gradeClazz.value;
        let stuName = this.refs.stuName.value;
        //获得内容的值
        this.setState({
            schoolName: schoolName,
            gradeClazz: gradeClazz,
            stuName: stuName,
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo }
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(GroupApply)
